import { I18n } from 'i18n-js';
import fr from '../locales/fr.json';

const i18n = new I18n({
  ...fr
});

i18n.defaultLocale = 'fr';
i18n.locale = document.documentElement.lang;

export default i18n;
